<template>
  <div>
    <div class="printer-edit-form">
      <div class="button-wrapper top">
        <div class="button" @click="savePrinter()">Save</div>
      </div>
      <div>
        <label>
          <span>type</span>
          <select v-model="printer.type" class="dashboard-select">
            <option v-for='type in types' :value="type">{{ type }}</option>
          </select>
        </label>
      </div>
      <div>
        <label>
          <span>manufacturer_id</span>
          <select v-model="printer.manufacturer_id" class="dashboard-select">
            <option v-for='manufacturer in manufacturers' :value="manufacturer.id">{{ manufacturer.name }}</option>
          </select>
        </label>
      </div>
      <div>
        <label>
          <span>model</span>
          <input type="text" v-model="printer.model">
        </label>
      </div>
      <div>
        <label>
          <span>image_url</span>
          <input type="text" v-model="printer.image_url">
        </label>
      </div>
      <div>
        <label>
          <span>speed_standard</span>
          <input type="text" v-model="printer.speed_standard">
        </label>
      </div>
      <div>
        <label>
          <span>auto_size_weight</span>
          <input type="text" v-model="printer.auto_size_weight">
        </label>
      </div>
      <div>
        <label>
          <span>scale_capacity</span>
          <input type="text" v-model="printer.scale_capacity">
        </label>
      </div>
      <div>
        <label>
          <span>envelope_thickness_capacity</span>
          <input type="text" v-model="printer.envelope_thickness_capacity">
        </label>
      </div>
      <div>
        <label>
          <span>programmable_jobs</span>
          <input type="text" v-model="printer.programmable_jobs">
        </label>
      </div>
      <div>
        <label>
          <span>departmental_accounting</span>
          <input type="text" v-model="printer.departmental_accounting">
        </label>
      </div>
      <div>
        <label>
          <span>ink_yield</span>
          <input type="text" v-model="printer.ink_yield">
        </label>
      </div>
      <div>
        <label>
          <span>ink_cost</span>
          <input type="text" v-model="printer.ink_cost">
        </label>
      </div>
      <div>
        <label>
          <span>ink_sell_price</span>
          <input type="text" v-model="printer.ink_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>ink_delivery_cost</span>
          <input type="text" v-model="printer.ink_delivery_cost">
        </label>
      </div>
      <div>
        <label>
          <span>cost_per_impression</span>
          <input type="text" v-model="printer.cost_per_impression">
        </label>
      </div>
      <div>
        <label>
          <span>label_pack_size</span>
          <input type="text" v-model="printer.label_pack_size">
        </label>
      </div>
      <div>
        <label>
          <span>label_pack_cost</span>
          <input type="text" v-model="printer.label_pack_cost">
        </label>
      </div>
      <div>
        <label>
          <span>label_pack_sell_price</span>
          <input type="text" v-model="printer.label_pack_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>cost_per_label</span>
          <input type="text" v-model="printer.cost_per_label">
        </label>
      </div>
      <div>
        <label>
          <span>return_address_capacity</span>
          <input type="text" v-model="printer.return_address_capacity">
        </label>
      </div>
      <div>
        <label>
          <span>return_address_included_with_machine</span>
          <input type="text" v-model="printer.return_address_included_with_machine">
        </label>
      </div>
      <div>
        <label>
          <span>return_address_cost</span>
          <input type="text" v-model="printer.return_address_cost">
        </label>
      </div>
      <div>
        <label>
          <span>return_address_sell_price</span>
          <input type="text" v-model="printer.return_address_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>business_mail_advanced</span>
          <input type="text" v-model="printer.business_mail_advanced">
        </label>
      </div>
      <div>
        <label>
          <span>business_mail_advanced_cost</span>
          <input type="text" v-model="printer.business_mail_advanced_cost">
        </label>
      </div>
      <div>
        <label>
          <span>business_mail_advanced_sell_price</span>
          <input type="text" v-model="printer.business_mail_advanced_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>interface_type</span>
          <input type="text" v-model="printer.interface_type">
        </label>
      </div>
      <div>
        <label>
          <span>mail_feeder</span>
          <input type="text" v-model="printer.mail_feeder">
        </label>
      </div>
      <div>
        <label>
          <span>label_dispenser</span>
          <input type="text" v-model="printer.label_dispenser">
        </label>
      </div>
      <div>
        <label>
          <span>web_based_reporting</span>
          <input type="text" v-model="printer.web_based_reporting">
        </label>
      </div>
      <div>
        <label>
          <span>differential_weighting</span>
          <input type="text" v-model="printer.differential_weighting">
        </label>
      </div>
      <div>
        <label>
          <span>dimensions</span>
          <input type="text" v-model="printer.dimensions">
        </label>
      </div>
      <div>
        <label>
          <span>printing_capabilities</span>
          <input type="text" v-model="printer.printing_capabilities">
        </label>
      </div>
      <div>
        <label>
          <span>shipping_application</span>
          <input type="text" v-model="printer.shipping_application">
        </label>
      </div>
      <div>
        <label>
          <span>shipping_application_kit_cost</span>
          <input type="text" v-model="printer.shipping_application_kit_cost">
        </label>
      </div>
      <div>
        <label>
          <span>shipping_application_kit_sell_price</span>
          <input type="text" v-model="printer.shipping_application_kit_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>integrated_internal_mail_tracking_app</span>
          <input type="text" v-model="printer.integrated_internal_mail_tracking_app">
        </label>
      </div>
      <div>
        <label>
          <span>integrated_internal_mail_tracking_cost</span>
          <input type="text" v-model="printer.integrated_internal_mail_tracking_cost">
        </label>
      </div>
      <div>
        <label>
          <span>integrated_internal_mail_tracking_sell_price</span>
          <input type="text" v-model="printer.integrated_internal_mail_tracking_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>integrated_internal_mail_tracking_service_cost</span>
          <input type="text" v-model="printer.integrated_internal_mail_tracking_service_cost">
        </label>
      </div>
      <div>
        <label>
          <span>integrated_internal_mail_tracking_service_sell_price</span>
          <input type="text" v-model="printer.integrated_internal_mail_tracking_service_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>connectivity</span>
          <input type="text" v-model="printer.connectivity">
        </label>
      </div>
      <div>
        <label>
          <span>connectivity_wifi_cost</span>
          <input type="text" v-model="printer.connectivity_wifi_cost">
        </label>
      </div>
      <div>
        <label>
          <span>connectivity_wifi_sell_price</span>
          <input type="text" v-model="printer.connectivity_wifi_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>connectivity_wifi_service_cost</span>
          <input type="text" v-model="printer.connectivity_wifi_service_cost">
        </label>
      </div>
      <div>
        <label>
          <span>connectivity_wifi_service_sell_price</span>
          <input type="text" v-model="printer.connectivity_wifi_service_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>connectivity_3g_cost</span>
          <input type="text" v-model="printer.connectivity_3g_cost">
        </label>
      </div>
      <div>
        <label>
          <span>connectivity_3g_sell_price</span>
          <input type="text" v-model="printer.connectivity_3g_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>connectivity_3g_service_cost</span>
          <input type="text" v-model="printer.connectivity_3g_service_cost">
        </label>
      </div>
      <div>
        <label>
          <span>connectivity_3g_service_sell_price</span>
          <input type="text" v-model="printer.connectivity_3g_service_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>mail_mark_compliant</span>
          <input type="text" v-model="printer.mail_mark_compliant">
        </label>
      </div>
      <div>
        <label>
          <span>mail_mark_kit_cost</span>
          <input type="text" v-model="printer.mail_mark_kit_cost">
        </label>
      </div>
      <div>
        <label>
          <span>mail_mark_kit_delivery_cost</span>
          <input type="text" v-model="printer.mail_mark_kit_delivery_cost">
        </label>
      </div>
      <div>
        <label>
          <span>mail_mark_kit_sell_price</span>
          <input type="text" v-model="printer.mail_mark_kit_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>mail_mark_service_cost</span>
          <input type="text" v-model="printer.mail_mark_service_cost">
        </label>
      </div>
      <div>
        <label>
          <span>mail_mark_service_sell_price</span>
          <input type="text" v-model="printer.mail_mark_service_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>mail_mark_upgraded_service_cover</span>
          <input type="text" v-model="printer.mail_mark_upgraded_service_cover">
        </label>
      </div>
      <div>
        <label>
          <span>mail_mark_upgraded_service_cover_sell_price</span>
          <input type="text" v-model="printer.mail_mark_upgraded_service_cover_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_1</span>
          <input type="text" v-model="printer.scale_option_1">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_1_cost</span>
          <input type="text" v-model="printer.scale_option_1_cost">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_1_sell_price</span>
          <input type="text" v-model="printer.scale_option_1_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_1_service</span>
          <input type="text" v-model="printer.scale_option_1_service">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_1_service_sell_price</span>
          <input type="text" v-model="printer.scale_option_1_service_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_2</span>
          <input type="text" v-model="printer.scale_option_2">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_2_cost</span>
          <input type="text" v-model="printer.scale_option_2_cost">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_2_sell_price</span>
          <input type="text" v-model="printer.scale_option_2_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_2_service</span>
          <input type="text" v-model="printer.scale_option_2_service">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_2_service_sell_price</span>
          <input type="text" v-model="printer.scale_option_2_service_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_3</span>
          <input type="text" v-model="printer.scale_option_3">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_3_cost</span>
          <input type="text" v-model="printer.scale_option_3_cost">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_3_sell_price</span>
          <input type="text" v-model="printer.scale_option_3_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_3_service</span>
          <input type="text" v-model="printer.scale_option_3_service">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_3_service_sell_price</span>
          <input type="text" v-model="printer.scale_option_3_service_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_4</span>
          <input type="text" v-model="printer.scale_option_4">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_4_cost</span>
          <input type="text" v-model="printer.scale_option_4_cost">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_4_sell_price</span>
          <input type="text" v-model="printer.scale_option_4_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_4_service</span>
          <input type="text" v-model="printer.scale_option_4_service">
        </label>
      </div>
      <div>
        <label>
          <span>scale_option_4_service_sell_price</span>
          <input type="text" v-model="printer.scale_option_4_service_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>differential_weighing_available</span>
          <input type="text" v-model="printer.differential_weighing_available">
        </label>
      </div>
      <div>
        <label>
          <span>differential_weighing_cost</span>
          <input type="text" v-model="printer.differential_weighing_cost">
        </label>
      </div>
      <div>
        <label>
          <span>differential_weighing_sell_price</span>
          <input type="text" v-model="printer.differential_weighing_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>accounting_option_1</span>
          <input type="text" v-model="printer.accounting_option_1">
        </label>
      </div>
      <div>
        <label>
          <span>accounting_option_1_cost</span>
          <input type="text" v-model="printer.accounting_option_1_cost">
        </label>
      </div>
      <div>
        <label>
          <span>accounting_option_1_sell_price</span>
          <input type="text" v-model="printer.accounting_option_1_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>accounting_option_2</span>
          <input type="text" v-model="printer.accounting_option_2">
        </label>
      </div>
      <div>
        <label>
          <span>accounting_option_2_cost</span>
          <input type="text" v-model="printer.accounting_option_2_cost">
        </label>
      </div>
      <div>
        <label>
          <span>accounting_option_2_sell_price</span>
          <input type="text" v-model="printer.accounting_option_2_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>accounting_option_3</span>
          <input type="text" v-model="printer.accounting_option_3">
        </label>
      </div>
      <div>
        <label>
          <span>accounting_option_3_cost</span>
          <input type="text" v-model="printer.accounting_option_3_cost">
        </label>
      </div>
      <div>
        <label>
          <span>accounting_option_3_sell_price</span>
          <input type="text" v-model="printer.accounting_option_3_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>>accounting_option_4</span>
          <input type="text" v-model="printer.accounting_option_4">
        </label>
      </div>
      <div>
        <label>
          <span>accounting_option_4_cost</span>
          <input type="text" v-model="printer.accounting_option_4_cost">
        </label>
      </div>
      <div>
        <label>
          <span>accounting_option_4_sell_price</span>
          <input type="text" v-model="printer.accounting_option_4_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>accounting_option_5</span>
          <input type="text" v-model="printer.accounting_option_5">
        </label>
      </div>
      <div>
        <label>
          <span>accounting_option_5_cost</span>
          <input type="text" v-model="printer.accounting_option_5_cost">
        </label>
      </div>
      <div>
        <label>
          <span>accounting_option_5_sell_price</span>
          <input type="text" v-model="printer.accounting_option_5_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>engineer_installation_training</span>
          <input type="text" v-model="printer.engineer_installation_training">
        </label>
      </div>
      <div>
        <label>
          <span>engineer_installation_training_cost</span>
          <input type="text" v-model="printer.engineer_installation_training_cost">
        </label>
      </div>
      <div>
        <label>
          <span>engineer_installation_training_sell_price</span>
          <input type="text" v-model="printer.engineer_installation_training_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>video_url</span>
          <input type="text" v-model="printer.video_url">
        </label>
      </div>
      <div>
        <label>
          <span>comparable_new_pb_equivalent</span>
          <input type="text" v-model="printer.comparable_new_pb_equivalent">
        </label>
      </div>
      <div>
        <label>
          <span>comparable_new_quadient_equivalent</span>
          <input type="text" v-model="printer.comparable_new_quadient_equivalent">
        </label>
      </div>
      <div>
        <label>
          <span>comparable_new_fp_equivalent</span>
          <input type="text" v-model="printer.comparable_new_fp_equivalent">
        </label>
      </div>
      <div>
        <label>
          <span>comparable_new_frama_equivalent</span>
          <input type="text" v-model="printer.comparable_new_frama_equivalent">
        </label>
      </div>
      <div>
        <label>
          <span>letters_per_day_recommendation</span>
          <input type="text" v-model="printer.letters_per_day_recommendation">
        </label>
      </div>
      <div>
        <label>
          <span>parcel_per_day_recommendation</span>
          <input type="text" v-model="printer.parcel_per_day_recommendation">
        </label>
      </div>
      <div>
        <label>
          <span>total_volume_per_day_recommendation</span>
          <input type="text" v-model="printer.total_volume_per_day_recommendation">
        </label>
      </div>
      <div>
        <label>
          <span>service_name</span>
          <input type="text" v-model="printer.service_name">
        </label>
      </div>
      <div>
        <label>
          <span>first_step</span>
          <input type="text" v-model="printer.first_step">
        </label>
      </div>
      <div>
        <label>
          <span>second_step</span>
          <input type="text" v-model="printer.second_step">
        </label>
      </div>
      <div>
        <label>
          <span>third_step</span>
          <input type="text" v-model="printer.third_step">
        </label>
      </div>
      <div>
        <label>
          <span>sla_standard</span>
          <input type="text" v-model="printer.sla_standard">
        </label>
      </div>
      <div>
        <label>
          <span>enhanced_service_name</span>
          <input type="text" v-model="printer.enhanced_service_name">
        </label>
      </div>
      <div>
        <label>
          <span>enhanced_third_step</span>
          <input type="text" v-model="printer.enhanced_third_step">
        </label>
      </div>
      <div>
        <label>
          <span>sla_enhanced</span>
          <input type="text" v-model="printer.sla_enhanced">
        </label>
      </div>
      <div>
        <label>
          <span>all_parts</span>
          <input type="text" v-model="printer.all_parts">
        </label>
      </div>
      <div>
        <label>
          <span>all_labour</span>
          <input type="text" v-model="printer.all_labour">
        </label>
      </div>
      <div>
        <label>
          <span>wear_and_tear</span>
          <input type="text" v-model="printer.wear_and_tear">
        </label>
      </div>
      <div>
        <label>
          <span>tariff_rate_updates_included_per_annum</span>
          <input type="text" v-model="printer.tariff_rate_updates_included_per_annum">
        </label>
      </div>
      <div>
        <label>
          <span>postage_deposit_account</span>
          <input type="text" v-model="printer.postage_deposit_account">
        </label>
      </div>
      <div>
        <label>
          <span>postage_deposit_account_cost_per_resets</span>
          <input type="text" v-model="printer.postage_deposit_account_cost_per_resets">
        </label>
      </div>
      <div>
        <label>
          <span>postage_recrediting_cost_per_annum</span>
          <input type="text" v-model="printer.postage_recrediting_cost_per_annum">
        </label>
      </div>
      <div>
        <label>
          <span>postage_credit_account_free_resets</span>
          <input type="text" v-model="printer.postage_credit_account_free_resets">
        </label>
      </div>
      <div>
        <label>
          <span>postage_credit_account_per_future_resets</span>
          <input type="text" v-model="printer.postage_credit_account_per_future_resets">
        </label>
      </div>
      <div>
        <label>
          <span>monthly_top_up_option_1</span>
          <input type="text" v-model="printer.monthly_top_up_option_1">
        </label>
      </div>
      <div>
        <label>
          <span>monthly_top_up_option_1_transaction_fee</span>
          <input type="text" v-model="printer.monthly_top_up_option_1_transaction_fee">
        </label>
      </div>
      <div>
        <label>
          <span>monthly_top_up_option_1_unlimited_transactions_monthly_fee</span>
          <input type="text" v-model="printer.monthly_top_up_option_1_unlimited_transactions_monthly_fee">
        </label>
      </div>
      <div>
        <label>
          <span>totalcare_transaction_fees_option_1</span>
          <input type="text" v-model="printer.totalcare_transaction_fees_option_1">
        </label>
      </div>
      <div>
        <label>
          <span>monthly_top_up_option_2</span>
          <input type="text" v-model="printer.monthly_top_up_option_2">
        </label>
      </div>
      <div>
        <label>
          <span>monthly_top_up_option_2_transaction_fee</span>
          <input type="text" v-model="printer.monthly_top_up_option_2_transaction_fee">
        </label>
      </div>
      <div>
        <label>
          <span>monthly_top_up_option_2_unlimited_transactions_monthly_fee</span>
          <input type="text" v-model="printer.monthly_top_up_option_2_unlimited_transactions_monthly_fee">
        </label>
      </div>
      <div>
        <label>
          <span>totalcare_transaction_fees_option_2</span>
          <input type="text" v-model="printer.totalcare_transaction_fees_option_2">
        </label>
      </div>
      <div>
        <label>
          <span>monthly_top_up_option_3</span>
          <input type="text" v-model="printer.monthly_top_up_option_3">
        </label>
      </div>
      <div>
        <label>
          <span>monthly_top_up_option_3_transaction_fee</span>
          <input type="text" v-model="printer.monthly_top_up_option_3_transaction_fee">
        </label>
      </div>
      <div>
        <label>
          <span>monthly_top_up_option_3_unlimited_transactions_monthly_fee</span>
          <input type="text" v-model="printer.monthly_top_up_option_3_unlimited_transactions_monthly_fee">
        </label>
      </div>
      <div>
        <label>
          <span>totalcare_transaction_fees_option_3</span>
          <input type="text" v-model="printer.totalcare_transaction_fees_option_3">
        </label>
      </div>
      <div>
        <label>
          <span>monthly_top_up_option_4</span>
          <input type="text" v-model="printer.monthly_top_up_option_4">
        </label>
      </div>
      <div>
        <label>
          <span>monthly_top_up_option_4_transaction_fee</span>
          <input type="text" v-model="printer.monthly_top_up_option_4_transaction_fee">
        </label>
      </div>
      <div>
        <label>
          <span>monthly_top_up_option_4_unlimited_transactions_monthly_fee</span>
          <input type="text" v-model="printer.monthly_top_up_option_4_unlimited_transactions_monthly_fee">
        </label>
      </div>
      <div>
        <label>
          <span>totalcare_transaction_fees_option_4</span>
          <input type="text" v-model="printer.totalcare_transaction_fees_option_4">
        </label>
      </div>
      <div>
        <label>
          <span>tme_ink_yield</span>
          <input type="text" v-model="printer.tme_ink_yield">
        </label>
      </div>
      <div>
        <label>
          <span>tme_ink_cost</span>
          <input type="text" v-model="printer.tme_ink_cost">
        </label>
      </div>
      <div>
        <label>
          <span>tme_ink_sell_price</span>
          <input type="text" v-model="printer.tme_ink_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>tme_delivery_cost</span>
          <input type="text" v-model="printer.tme_delivery_cost">
        </label>
      </div>
      <div>
        <label>
          <span>tme_cost_per_impression</span>
          <input type="text" v-model="printer.tme_cost_per_impression">
        </label>
      </div>
      <div>
        <label>
          <span>tme_label_pack_size</span>
          <input type="text" v-model="printer.tme_label_pack_size">
        </label>
      </div>
      <div>
        <label>
          <span>tme_label_pack_cost</span>
          <input type="text" v-model="printer.tme_label_pack_cost">
        </label>
      </div>
      <div>
        <label>
          <span>tme_label_pack_sell_price</span>
          <input type="text" v-model="printer.tme_label_pack_sell_price">
        </label>
      </div>
      <div>
        <label>
          <span>tme_cost_per_label</span>
          <input type="text" v-model="printer.tme_cost_per_label">
        </label>
      </div>
      <div class="button-wrapper bottom">
        <div class="button" @click="savePrinter()">Save</div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {

    created() {
      this.printer_id = this.$route.params.id

      this.axios.all([
        this.axios.get('/printers/' + this.printer_id),
        this.axios.get('/manufacturers')
      ]).then(this.axios.spread((printer, manufacturers) => {
        this.printer = printer.data
        this.manufacturers = manufacturers.data

        // add title to labels
        $('label span').each(function() {
          var label = $(this).text();
          $(this).attr('title', label);
        });

        // add active class on focus
        $('input, select').on('focusin', function() {
          $(this).parents('label').addClass('is-focused');
        }).on('focusout', function() {
          $(this).parents('label').removeClass('is-focused');
        });
      }))
    },

    data() {
      return {
        printer_id: null,
        printer: {
          type: null,
          manufacturer_id: null,
          model: null,
          image_url: null,
          speed_standard: null,
          auto_size_weight: null,
          scale_capacity: null,
          envelope_thickness_capacity: null,
          programmable_jobs: null,
          departmental_accounting: null,
          ink_yield: null,
          ink_cost: null,
          ink_sell_price: null,
          ink_delivery_cost: null,
          cost_per_impression: null,
          label_pack_size: null,
          label_pack_cost: null,
          label_pack_sell_price: null,
          cost_per_label: null,
          return_address_capacity: null,
          return_address_included_with_machine: null,
          return_address_cost: null,
          return_address_sell_price: null,
          business_mail_advanced: null,
          business_mail_advanced_cost: null,
          business_mail_advanced_sell_price: null,
          interface_type: null,
          mail_feeder: null,
          label_dispenser: null,
          web_based_reporting: null,
          differential_weighting: null,
          dimensions: null,
          printing_capabilities: null,
          shipping_application: null,
          shipping_application_kit_cost: null,
          shipping_application_kit_sell_price: null,
          integrated_internal_mail_tracking_app: null,
          integrated_internal_mail_tracking_cost: null,
          integrated_internal_mail_tracking_sell_price: null,
          integrated_internal_mail_tracking_service_cost: null,
          integrated_internal_mail_tracking_service_sell_price: null,
          connectivity: null,
          connectivity_wifi_cost: null,
          connectivity_wifi_sell_price: null,
          connectivity_wifi_service_cost: null,
          connectivity_wifi_service_sell_price: null,
          connectivity_3g_cost: null,
          connectivity_3g_sell_price: null,
          connectivity_3g_service_cost: null,
          connectivity_3g_service_sell_price: null,
          mail_mark_compliant: null,
          mail_mark_kit_cost: null,
          mail_mark_kit_delivery_cost: null,
          mail_mark_kit_sell_price: null,
          mail_mark_service_cost: null,
          mail_mark_service_sell_price: null,
          mail_mark_upgraded_service_cover: null,
          mail_mark_upgraded_service_cover_sell_price: null,
          scale_option_1: null,
          scale_option_1_cost: null,
          scale_option_1_sell_price: null,
          scale_option_1_service: null,
          scale_option_1_service_sell_price: null,
          scale_option_2: null,
          scale_option_2_cost: null,
          scale_option_2_sell_price: null,
          scale_option_2_service: null,
          scale_option_2_service_sell_price: null,
          scale_option_3: null,
          scale_option_3_cost: null,
          scale_option_3_sell_price: null,
          scale_option_3_service: null,
          scale_option_3_service_sell_price: null,
          scale_option_4: null,
          scale_option_4_cost: null,
          scale_option_4_sell_price: null,
          scale_option_4_service: null,
          scale_option_4_service_sell_price: null,
          differential_weighing_available: null,
          differential_weighing_cost: null,
          differential_weighing_sell_price: null,
          accounting_option_1: null,
          accounting_option_1_cost: null,
          accounting_option_1_sell_price: null,
          accounting_option_2: null,
          accounting_option_2_cost: null,
          accounting_option_2_sell_price: null,
          accounting_option_3: null,
          accounting_option_3_cost: null,
          accounting_option_3_sell_price: null,
          accounting_option_4: null,
          accounting_option_4_cost: null,
          accounting_option_4_sell_price: null,
          accounting_option_5: null,
          accounting_option_5_cost: null,
          accounting_option_5_sell_price: null,
          engineer_installation_training: null,
          engineer_installation_training_cost: null,
          engineer_installation_training_sell_price: null,
          video_url: null,
          comparable_new_pb_equivalent: null,
          comparable_new_quadient_equivalent: null,
          comparable_new_fp_equivalent: null,
          comparable_new_frama_equivalent: null,
          letters_per_day_recommendation: null,
          parcel_per_day_recommendation: null,
          total_volume_per_day_recommendation: null,
          service_name: null,
          first_step: null,
          second_step: null,
          third_step: null,
          sla_standard: null,
          enhanced_service_name: null,
          enhanced_third_step: null,
          sla_enhanced: null,
          all_parts: null,
          all_labour: null,
          wear_and_tear: null,
          tariff_rate_updates_included_per_annum: null,
          postage_deposit_account: null,
          postage_deposit_account_cost_per_resets: null,
          postage_recrediting_cost_per_annum: null,
          postage_credit_account_free_resets: null,
          postage_credit_account_per_future_resets: null,
          monthly_top_up_option_1: null,
          monthly_top_up_option_1_transaction_fee: null,
          monthly_top_up_option_1_unlimited_transactions_monthly_fee: null,
          totalcare_transaction_fees_option_1: null,
          monthly_top_up_option_2: null,
          monthly_top_up_option_2_transaction_fee: null,
          monthly_top_up_option_2_unlimited_transactions_monthly_fee: null,
          totalcare_transaction_fees_option_2: null,
          monthly_top_up_option_3: null,
          monthly_top_up_option_3_transaction_fee: null,
          monthly_top_up_option_3_unlimited_transactions_monthly_fee: null,
          totalcare_transaction_fees_option_3: null,
          monthly_top_up_option_4: null,
          monthly_top_up_option_4_transaction_fee: null,
          monthly_top_up_option_4_unlimited_transactions_monthly_fee: null,
          totalcare_transaction_fees_option_4: null,
          tme_ink_yield: null,
          tme_ink_cost: null,
          tme_ink_sell_price: null,
          tme_delivery_cost: null,
          tme_cost_per_impression: null,
          tme_label_pack_size: null,
          tme_label_pack_cost: null,
          tme_label_pack_sell_price: null,
          tme_cost_per_label: null,
        },
        manufacturers: [],
        types: [
          'CURRENT',
          'LEGACY'
        ],
      }
    },

    methods: {
      savePrinter() {
        this.axios.put('/printers/' + this.printer_id, this.printer).then(response => {
          if (response.status === 202) {
            this.printer = response.data
            alert('Updated!')
          }
        })
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/views/Printers/Edit.vue